<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" @close="close" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="上传的物流单号">
          <el-select
              v-model="formInline.trackNumber"
              multiple
              filterable
              allow-create
              reserve-keyword
              placeholder="请选择物流单号"
              remote-show-suffix
              :loading="loading"
              style="width: 240px"
          >
            <el-option
                v-for="item in trackNumberList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图片识别物流单号">
          <el-input  style="width: 240px" v-model="formInline.rearTrackNumber" placeholder="请输入真实物流单号" ></el-input>
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElMessage,ElSelect,ElOption,ElInput} from "element-plus";
import {getFullUrl,isValidEmail,getLocalStockList} from "@/../public/js/index"
import {uploadUrl} from "@/utils/requset";
import {updateTempInStoreTrack,getTempInStoreTrack} from "@/utils/api"
export default {
  name: "addInStoreTrack",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElSelect,ElOption,ElInput
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      dialogTableVisible:false,
      title:"更新物流单号",
      botton:"保存",
      formInline:{

      },
      reMarks:false,

      trackNumberList:[],
      uploadUrl:'',
      dialogVisible:false
    }
  },
  beforeMount(){
    this.uploadUrl = uploadUrl
    this.getLocalStockList()

  },
  methods:{
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    getTempInStoreTrack(data){
      getTempInStoreTrack(data).then(res=>{
          this.trackNumberList = res.Data
      }).catch(err=>{
        console.log(err)
      })
    },
    open(data){
      console.log(data)
      this.dialogTableVisible=true
      this.formInline = {
        tempInStoreId:data.tempInStoreId,
        trackNumber:data.trackNumber,
        rearTrackNumber:data.rearTrackNumber,
      }
      this.getTempInStoreTrack({tempInStoreId:data.tempInStoreId})
    },
    onSubmit(){
      console.log(this.formInline)
      if(!this.formInline.rearTrackNumber){
        ElMessage.warning('请输入真实物流单号')
        return
      }

      updateTempInStoreTrack(this.formInline).then(res=>{
          console.log(res)
          this.dialogTableVisible=false
          ElMessage.success('保存成功')
      }).catch(err=>{
        console.log(err)
      })
    },
    close(){
      this.dialogTableVisible = false
      this.$emit('closeEdit')
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
.span{
  color: #f56c6c;
  font-size: 12px;
}

</style>